import { type AppIconName } from '@/components/icons'
import { getRoutePolicyById, getAllRequiredPermissions } from '@/constants'

export interface NavSubItem {
  id: string
  labelKey: string
  icon: AppIconName
  path: string
  requiredPermissions: readonly string[]
}

export interface NavItem {
  id: string
  labelKey: string
  icon: AppIconName
  path?: string
  requiredPermissions?: readonly string[]
  subItems?: NavSubItem[]
}

const dashboard = getRoutePolicyById('dashboard')
const checkout = getRoutePolicyById('checkout')
const salesHistory = getRoutePolicyById('sales-history')
const productsCatalog = getRoutePolicyById('products-catalog')
const inventoryLots = getRoutePolicyById('inventory-lots')
const reportsStock = getRoutePolicyById('reports-stock')
const users = getRoutePolicyById('users')
const rolesPermissions = getRoutePolicyById('roles-permissions')

export const navItems: NavItem[] = [
  {
    id: 'inicio',
    labelKey: 'layout.menu.home',
    icon: 'home',
    path: dashboard.path,
    requiredPermissions: getAllRequiredPermissions(dashboard),
  },
  {
    id: 'caja',
    labelKey: 'layout.menu.newSale',
    icon: 'shoppingCart',
    path: checkout.path,
    requiredPermissions: getAllRequiredPermissions(checkout),
  },
  {
    id: 'ventas',
    labelKey: 'layout.menu.history',
    icon: 'dollarSign',
    path: salesHistory.path,
    requiredPermissions: getAllRequiredPermissions(salesHistory),
  },
  {
    id: 'productos',
    labelKey: 'layout.menu.products',
    icon: 'package',
    path: productsCatalog.path,
    requiredPermissions: getAllRequiredPermissions(productsCatalog),
  },
  {
    id: 'inventario',
    labelKey: 'layout.menu.lots',
    icon: 'archive',
    path: inventoryLots.path,
    requiredPermissions: getAllRequiredPermissions(inventoryLots),
  },
  {
    id: 'reportes',
    labelKey: 'layout.menu.reports',
    icon: 'barChart',
    subItems: [
      {
        id: 'reporte-stock',
        labelKey: 'layout.menu.reportStock',
        icon: 'package',
        path: reportsStock.path,
        requiredPermissions: getAllRequiredPermissions(reportsStock),
      },
    ],
  },
  {
    id: 'administracion',
    labelKey: 'layout.menu.admin',
    icon: 'users',
    subItems: [
      {
        id: 'usuarios',
        labelKey: 'layout.menu.users',
        icon: 'user',
        path: users.path,
        requiredPermissions: getAllRequiredPermissions(users),
      },
      {
        id: 'roles-permisos',
        labelKey: 'layout.menu.roles',
        icon: 'shield',
        path: rolesPermissions.path,
        requiredPermissions: getAllRequiredPermissions(rolesPermissions),
      },
      {
        id: 'configuracion',
        labelKey: 'layout.menu.settings',
        icon: 'settings',
        path: '/administracion/configuracion',
        requiredPermissions: [],
      },
    ],
  },
]
